export const UNAUTHORISED_ADVERTISEMENTS = 'UnauthorisedAdvertisements';
export const UNAUTHORISED_CHANGE_OF_USE = 'UnauthorisedChangeOfUse';
export const UNAUTHORISED_INSTALLATION =
  'UnauthorisedInstallationOfPlantOrEquipment';
export const UNAUTHORISED_WORKS = 'UnauthorisedWorksIncludingToListedBuildings';
export const BREACH_OF_PLANNING = 'BreachOfPlanningConditions';
export const SHORT_TERM_LETS = 'ShortTermLets';

export const MAX_LENGTH = 500;

export const WHO_IS_RESPONSIBLE_ERROR_TEXT =
  'Enter details about who is causing the issue.';
export const WHO_IS_RESPONSIBLE_ERROR_TEXT_MAX_LENGTH_MESSAGE = `Details about who is causing the issue must be ${MAX_LENGTH} characters or less.`;
